import React from "react";
import SEO from "../components/SEO";

const Privacy = () => {
  return (

    <>
      <SEO
        title='Privacy'
        description='Shirts Patches'
        keywords='Shirts Patches'
      />
      <div className="relative bg-gradient-to-br from-[#eef6f3] via-white to-[#e8f1ee] overflow-hidden">

        {/* Decorative Blobs */}
        <div className="absolute -top-48 -right-48 w-[420px] h-[420px] bg-[#437d6a]/20 rounded-full blur-3xl" />
        <div className="absolute -bottom-48 -left-48 w-[420px] h-[420px] bg-[#437d6a]/10 rounded-full blur-3xl" />

        <div className="relative container mx-auto px-4 py-28 max-w-6xl">

          {/* Header */}
          <div className="text-center mb-24">
            <span className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white/70 backdrop-blur border border-[#437d6a]/30 text-[#437d6a] font-semibold shadow-sm">
              Privacy & Data Protection
            </span>

            <h1 className="mt-8 text-4xl md:text-6xl font-extrabold text-gray-900 tracking-tight">
              Privacy Policy
            </h1>

            <p className="mt-8 max-w-3xl mx-auto text-lg text-gray-600 leading-relaxed">
              Learn how{" "}
              <span className="font-semibold text-[#437d6a]">
                Personalised Hat Patches
              </span>{" "}
              collects, uses, and protects your personal information.
            </p>
          </div>

          {/* Main Glass Card */}
          <div className="bg-white/85 backdrop-blur-xl rounded-[36px] shadow-2xl border border-gray-200 p-10 md:p-16 space-y-20">

            {/* Intro */}
            <div className="bg-[#437d6a]/5 rounded-3xl p-8 border border-[#437d6a]/15">
              <p className="text-lg text-gray-700 leading-relaxed">
                This Privacy Policy explains how{" "}
                <span className="font-semibold text-gray-900">
                  Personalised Hat Patches
                </span>{" "}
                (“we”, “our”, “us”) collects, uses, stores, and safeguards
                information from users (“you”, “your”) when accessing our website
                and services.
              </p>
            </div>

            {/* Policy Sections */}
            {[
              {
                icon: "👤",
                title: "Personal & Business Information",
                text: [
                  "We collect personal information when you place orders, upload designs, contact support, or interact with our website.",
                  "This may include your name, email address, phone number, mailing address, payment details, and uploaded artwork.",
                  "Calls may be recorded for quality and training purposes. Technical data such as IP address, browser type, and device information may also be collected.",
                ],
              },
              {
                icon: "📊",
                title: "Non-Personal Information",
                text: [
                  "We may collect non-identifying information such as browser type, device, operating system, and internet service provider to improve user experience.",
                ],
              },
              {
                icon: "🍪",
                title: "Cookies & Tracking Technologies",
                text: [
                  "Cookies and tracking technologies are used to enhance usability, analyze traffic, and support advertising campaigns.",
                  "You may disable cookies via your browser, though some site features may not function correctly.",
                ],
              },
              {
                icon: "⚙️",
                title: "How We Use Your Information",
                text: [
                  "Your information helps us process orders, improve services, personalize experiences, and communicate important updates.",
                  "By providing contact details, you consent to receive transactional and marketing communications.",
                  "You may opt out anytime by replying STOP or unsubscribe via email.",
                ],
              },
              {
                icon: "🛡️",
                title: "Data Protection & Security",
                text: [
                  "We use SSL encryption and industry-standard security measures to protect your data.",
                  "Despite best efforts, no method of data transmission is completely secure.",
                ],
              },
              {
                icon: "🤝",
                title: "Information Sharing",
                text: [
                  "We never sell your personal information.",
                  "Data is shared only with trusted partners necessary for order fulfillment, operations, or legal compliance.",
                ],
              },
              {
                icon: "🕒",
                title: "Data Retention & Do Not Track",
                text: [
                  "Information may be retained for legal or operational purposes unless deletion is requested.",
                  "We currently do not respond to Do Not Track browser signals.",
                ],
              },
              {
                icon: "✏️",
                title: "Policy Updates",
                text: [
                  "This Privacy Policy may be updated periodically.",
                  "We recommend reviewing this page to stay informed about changes.",
                ],
              },
            ].map((section, index) => (
              <section
                key={index}
                className="relative bg-white rounded-3xl border border-gray-200 p-8 shadow-sm hover:shadow-md transition"
              >
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#437d6a]/15 text-[#437d6a] text-2xl">
                    {section.icon}
                  </div>
                  <h2 className="text-2xl font-bold text-gray-900">

                    {section.title}
                  </h2>
                </div>

                <div className="space-y-3 text-gray-700 leading-relaxed">
                  {section.text.map((line, i) => (
                    <p key={i}>{line}</p>
                  ))}
                </div>
              </section>
            ))}

            {/* Contact Card */}
            <section className="bg-gradient-to-br from-[#437d6a] to-[#356b5a] rounded-3xl p-10 text-white shadow-xl">
              <h2 className="text-2xl font-bold mb-4">
                Questions About Your Privacy?
              </h2>
              <p className="text-white/90 mb-6">
                Our support team is available to help with privacy or data-related
                inquiries.
              </p>

              <div className="space-y-1 text-white/90">
                <p className="font-semibold">Personalised Hat Patches</p>
                <p>Email: support@personalisedhatpatches.com</p>
                <p>Phone: (703) 666-8193</p>
              </div>
            </section>

            {/* Footer */}
            <p className="text-sm text-gray-500 text-center pt-10 border-t">
              Last updated on 11/20/24
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Privacy;
